import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const STORAGE_KEY = "painur-cookie-consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) {
        // small delay to avoid layout shift on first paint
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const decide = (value: "accepted" | "declined") => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      dir="rtl"
      role="dialog"
      aria-live="polite"
      aria-label="הסכמה לשימוש בעוגיות"
      className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4 pointer-events-none"
    >
      <div className="pointer-events-auto relative mx-auto max-w-3xl rounded-2xl border border-border/60 bg-background/95 backdrop-blur-md shadow-2xl p-4 sm:p-5 text-right">
        <button
          onClick={() => decide("declined")}
          aria-label="סגור"
          className="absolute top-2 left-2 p-1 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
        <h2 className="text-base sm:text-lg font-bold mb-1">אנחנו משתמשים בעוגיות 🍪</h2>
        <p className="text-sm text-muted-foreground leading-relaxed mb-4">
          אנו משתמשים בעוגיות כדי לשפר את חוויית הגלישה שלך, לנתח את השימוש באתר ולהציע תוכן מותאם.
          לפרטים נוספים ניתן לעיין ב
          <Link to="/privacy-policy" className="text-primary hover:underline mx-1">
            מדיניות הפרטיות
          </Link>
          שלנו.
        </p>
        <div dir="rtl" className="flex flex-row-reverse flex-wrap gap-2 justify-start">
          <Button onClick={() => decide("accepted")} size="sm" className="min-w-[110px]">
            אישור
          </Button>
          <Button onClick={() => decide("declined")} size="sm" variant="outline" className="min-w-[110px]">
            דחייה
          </Button>
        </div>
      </div>
    </div>
  );
}

export { STORAGE_KEY as COOKIE_CONSENT_STORAGE_KEY };
